import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=00c6b89d&"
import script from "./EmployeeInfo.vue?vue&type=script&lang=ts&"
export * from "./EmployeeInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports